import React, { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Container from 'react-bootstrap/Container';
import Answerii from "./Answerii";
import Itom from "./Itom";


function App() {
  return (
      <Container fluid="md" >
          <BrowserRouter>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Itom />} />
                </Routes>
            </div>
          </BrowserRouter>
      </Container>
  );
}

export default App;
